/**
 * Fixed set of cartoon avatar emoji (spec §2.1). The list itself lives with the UI kit
 * (`@/ui/avatars`, a pure module) so the picker, the Twemoji bundle and identity validation agree.
 */
import { AVATARS, type AvatarEmoji } from '@/ui/avatars';

export { AVATARS };
export type Avatar = AvatarEmoji;

export function isAvatar(value: unknown): value is Avatar {
  return typeof value === 'string' && (AVATARS as readonly string[]).includes(value);
}

export function randomAvatar(): Avatar {
  const i = Math.floor(Math.random() * AVATARS.length);
  return AVATARS[i] ?? AVATARS[0];
}
